<app-nav></app-nav>
<section class="wallet">
  <div class="point-section">
      <h4>Your Wallet Points</h4>
      <h5>₹{{referralData.Balance}}</h5>
      <p>(1 point = ₹1 of Amazon Voucher)</p>
      
      <button (click)="openModal(redeemReward)" [disabled]="referralData.Balance === 0"   *ngIf="referralData.Balance !== 1" class="btn btn-orange mt-2">Redeem Now</button>
      <button class="btn btn-orange mt-2" routerLink="/referrallist" style="margin-left:10px">Referral List</button>
      
      <button style="margin-left:10px"  routerLink="/refer" class="btn btn-orange mt-2">Refer Product</button>
      <!-- <button style="margin-left:10px"  routerLink="/articles" *ngIf="referralData.Balance === 0" class="btn btn-orange mt-2">Refer Article</button> -->
      <!-- *ngIf="referralData.Balance === 0" -->
  </div>
  <div class="conditions">
    <p>Conditions:</p>
    <ul>
      <li>- Minimum amount for redemption is at least 500 points</li>
      <li>- It will take 48-72 working hours to credit Amazon voucher 
          on your email</li>
    </ul>
  </div> 
  <div class="wallet-history">
    <h5>Wallet History</h5>
    <ul *ngIf="referralData.passbook_data.length > 0">
      <li *ngFor="let history of referralData.passbook_data">
        <div class="amount-cricle">₹{{history.Amount}}</div>
        <div class="history-right">
          <h6>{{history.Remark}}</h6>
          <p>{{history.created | date}}</p>
        </div>
      </li>
    </ul>
    <p class="sml-font" *ngIf="referralData.passbook_data.length === 0">No history found</p>
  </div> 
</section>


<ng-template #redeemReward>
    <div class="modal-body redeem-modal">
      <ng-container *ngIf="!redeemSuccess">
        <h4 id="errorMessage"></h4>
        <h4>Redeem Wallet Points to Get Amazon Voucher</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="amount">₹{{referralData.Balance}}</div>
        <p>- Redeemable amount should be a mutilple of 500, in order to win Amazon vouchers</p>
        <form class="form-inline">
          <div class="form-group row flex-center mt-4">
            <label class="col-7 redeem-label">Redeemable Amount</label>
            <div class="col-5">
              <input type="number" [(ngModel)]="redeemAmount" name="redeemAmount" disabled class="form-control" />
            </div>
          </div>
          <div class="col-12">
            <button [disabled]="redeemAmount === 0" class="btn btn-orange mt-4" (click)="redeemWalletPoints()">Redeem</button>
          </div>

         
        </form>
      </ng-container>
      <ng-container *ngIf="redeemSuccess">
        <h4>Redeemed Successfully</h4>
        <p class="mt-4 mb-4 text-center">Redemption amount will be credited in 
          48-72 hours to your email address</p>
        <button class="btn btn-orange" (click)="modalRef.hide()">Done</button>
      </ng-container>
    </div>

</ng-template>

<div id="spinner" [hidden]="!loading">
  <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
</div>